/**
 * Recency math for the Live Tap renderer — the one definition of "how much is a
 * sentence worth now", shared by the reducer (buffer eviction, the stamped
 * `effectiveScore`) and by curated slot filling, which layers its own per-slot
 * temperaments on top of it (see TIERS in fillSlots.js).
 *
 * A sentence's weight is `score × decay(age)`, where age is measured in
 * SENTENCES (the renderer's clock — see useTapestryState) and the decay halves
 * every `halfLife` sentences toward `floor` (never zero, so a dominant early
 * quote fades rather than vanishing outright).
 *
 * Pure functions — no state, no I/O.
 */

// Default decay: the reducer's own scale. The old half-life (25) was in
// corpus-era display segments of ~several sentences each; 80 keeps the same
// decay scale at the sentence clock.
export const RECENCY_HALFLIFE = 80;
export const RECENCY_FLOOR = 0.3;

/**
 * Recency-weighted score of a buffered sentence at sentence-index `now`.
 * A `floor` of 1 (or an infinite half-life) means no decay at all — the raw
 * salience score, which is what the recency-neutral slot temperament wants.
 */
export function decayedScore(sent, now, halfLife = RECENCY_HALFLIFE, floor = RECENCY_FLOOR) {
  const age = Math.max(0, now - (sent.idx ?? now));
  return (sent.score || 0) * (floor + (1 - floor) * Math.pow(0.5, age / halfLife));
}

/** The reducer's own scale — what `state.symbols[*].sentences[*].effectiveScore` holds. */
export function effectiveScore(sent, now) {
  return decayedScore(sent, now);
}
